import model from 'modules/botFlow/botFlowModel';

const { fields } = model;

export default [
  fields.id,
  fields.name,
  fields.phoneNumberId,
  fields.messages,
  fields.cluster,
  fields.enable,
  fields.createdAt,
  fields.updatedAt,
];
